import { IonCol, IonRow, IonText } from '@ionic/react';

import styles from '@/components/DataTable/DataTable.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

interface DataTableHeaderProps {
  titles: string[];
}

export const DataTableHeader = ({ titles }: DataTableHeaderProps) => {
  return (
    <IonRow className='ion-justify-content-end ion-align-items-center'>
      {titles.map((title, index) => (
        <IonCol className={mergeClassNames(styles.column, 'ion-text-center')} key={index}>
          <IonText className={styles.title}>{title}</IonText>
        </IonCol>
      ))}
    </IonRow>
  );
};
